<template>
  <div class="fullPage">
    <template v-if="init === 1">
      <transition name="slide-x-transition" mode="out-in">
        <router-view :key="routeKey">
        </router-view>
      </transition>
    </template>
    <template v-else>
      <page :manualInit="init" :manualErr="computedErr" @reload="doReload">
      </page>
    </template>
  </div>
</template>

<script>
import { ObjectByString } from '@/utils'
// Use this page only if there is nothing to display on this route (use to render sub route only)
export default {
  data() {
    return {
      init: 2
    }
  },
  computed: {
    computedInit() {
      if (this.initField === undefined) {
        return 1
      } else {
        try {
          const result = ObjectByString(this.$store.state, this.initField)
          if (result === 0 || result === 1 || result === 2) {
            return result
          } else {
            return 2
          }
        } catch (err) {
          return 2
        }
      }
    },
    computedErr() {
      if (this.initErr === undefined) {
        return []
      } else {
        const err = ObjectByString(this.$store.state, this.initErr)
        if (err) {
          return err
        } else {
          return []
        }
      }
    },
    routeKey() {
      if (this.routeMatchLevel && this.$route.matched.length >= this.routeMatchLevel) {
        return this.$route.matched[this.routeMatchLevel].name
      }
      return ''
    }
  },
  watch: {
    'computedInit': function (value) {
      this.init = value
    }
  },
  methods: {
    doInit() {
      // Dispatch the method to init
      this.$store.dispatch(this.initMethod)
      // Cannot do try catch for dispatch. If error encounted, it will be perma loading
      // If by 10 secs still not ready, push it to failure state
      setTimeout(() => {
        if (this.init === 0) {
          this.init = 2
        }
      }, 10000)
    },
    doReload() {
      this.doInit()
    }
  },
  beforeMount() {
    this.init = this.computedInit
  },
  mounted() {
    if (this.init === 0) {
      // If this subroute requires an init, a valid action must be passed in
      if (this.initMethod === undefined) {
        this.init = 2
      } else {
        this.doInit()
      }
    }
  },
  props: {
    initField: {
      type: String,
      default: undefined
    },
    initMethod: {
      type: String,
      default: undefined
    },
    initErr: {
      type: String,
      default: undefined
    },
    routeMatchLevel: {
      type: Number,
      default: null
    }
  }
}
</script>

<style lang="scss">
</style>
